import { MtProject } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { ProjectSettings } from "client/store"
import * as types from "./types"


export const setProjectList = (projectList: types.ProjectList) => ({
    type: inferLiteral(types.PROJECT_LIST),
    projectList,
})
export const setProjectIds = (projectIds: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_IDS),
    projectIds,
})
export const setProjectView = (project: MtProject) => ({
    type: inferLiteral(types.PROJECT_VIEW),
    project,
})
export const setProjectEdit = (project: MtProject) => ({
    type: inferLiteral(types.PROJECT_EDIT),
    project,
})
export const setProjectProjectSettings = (settings: ProjectSettings) => ({
    type: inferLiteral(types.PROJECT_PROJECT_SETTINGS),
    settings,
})
export const setProjectSort = (sortColumn: keyof MtProject, sortOrder: OrderType) => ({
    type: inferLiteral(types.PROJECT_SORT),
    sortColumn,
    sortOrder,
})
export const setProjectFilters = (filters: types.ProjectFilters) => ({
    type: inferLiteral(types.PROJECT_FILTERS),
    filters,
})
export const setProjectReloadList = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_RELOAD_LIST),
    value,
})
export const setProjectReloadView = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_RELOAD_VIEW),
    value,
})
export const setProjectReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_RELOAD_EDIT),
    value,
})
